import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import integrador from "./integrador";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        errors: [],
        error: null,
        loading: false,
        loadings: 0,
    },

    getters: {
        errors: state => state.errors,
        error: state => state.error,
        loading: state => state.loading
    },

    mutations: {
        setErrors(state, errors) {
            state.errors = errors;
        },
        setError(state, error) {
            state.error = error;
        },
        setLoading(state, loading) {
            if (loading) {
                state.loadings = Math.max(0, state.loadings + 1);
            } else {
                state.loadings = Math.max(0, state.loadings - 1);
            }
            state.loading = (state.loadings > 0);
        },
        resetLoading(state) {
            state.loadings = 0;
            state.loading = false;
        }
    },

    actions: {},

    modules: {
        auth,
        integrador
    }
});